<template>
  <div class="genre-main" :class="`${createRenderType}-genre-main`">
    <div v-if="!loading">
      <div class="genre-box" v-for="item in genreSong" :key="item.id">
        <div class="genre-title flex-space-between">
          <span>
            {{
              constTags
                .getRenderLabel(
                  [item.name],
                  constTags.StyleLabelData.map,
                  $$language()
                )
                ?.join("") || item?.name
            }}</span
          >
          <span
            class="more pointer flex-center"
            @click="handleGoGenreDetail(item)"
            >{{ $$t("create.more") }}</span
          >
        </div>
        <div class="flex genre-list" style="flex-wrap: wrap">
          <div
            v-for="citem in item.feeds"
            :key="citem?.song?.song_id"
            class="genre-item"
          >
            <GenreCard
              :data="citem"
              type="genre"
              @changeFavorite="(state) => changeFavorite(citem, state)"
              @handleMore="handleMore(citem)"
              @togglePlay="togglePlay(citem)"
              @handleShare="handleShare(citem)"
              @onCurPlayEnded="onCurPlayEnded(citem)"
            ></GenreCard>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-skeleton
        v-for="item in 4"
        :key="item"
        class="skeleton-box"
        :class="`${createRenderType}-skeleton-box`"
        :rows="5"
        :style="{
          '--el-fill-color': 'rgb(255, 255, 255, 0.1)',
        }"
      />
    </div>
  </div>
</template>

<script setup>
import { defineEmits, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import useDiscoverStore from "@/store/discover/discoverDataStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import constTags from "@/config/const.js";
import GenreCard from "./genreCard.vue";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t, $$language } = globalProperties?.$i18n;
const router = useRouter();
const discoverDataStore = useDiscoverStore();
const { genreSong } = storeToRefs(discoverDataStore);
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits([
  "handleMore",
  "changeFavorite",
  "togglePlay",
  "onCurPlayEnded",
  "handleShare",
  "handleSimilar",
]);
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
const changeFavorite = (item, state) => {
  emits("changeFavorite", item, state);
};

const handleShare = (item) => {
  emits("handleShare", item);
};

const togglePlay = (item) => {
  emits("togglePlay", item);
};

const onCurPlayEnded = (item) => {
  emits("onCurPlayEnded", item);
};

const handleGoGenreDetail = (item) => {
  globalProperties.logClickEvent("home_genres_more", {
    entity: "home_genres_more",
  });
  const { id, name, last_id } = item;
  discoverDataStore.clearGenreListTotal();
  router.push({
    name: "GenreDetail",
    params: {
      last_id,
      id,
      name
    },
  });
};
</script>

<style lang="scss" scoped>
.pc-genre-main {
  .genre-box {
    padding-top: 12px;
    margin-bottom: 22px;

    &:first-of-type {
      padding-top: 0px;
    }
    .genre-title {
      padding-right: 20px;
      font-size: 32px;
      font-weight: bold;
      line-height: 42px;
      span {
        &:first-of-type {
          text-transform: capitalize;
        }
      }
      .change-btn {
        .btn-item {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          margin-left: 12px;
          &-disabled {
            opacity: 0.3;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        .pointer {
          &:hover {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
      .more {
        font-size: 16px;
        font-weight: 500;
        line-height: 36px;
        border-radius: 30px;
        padding: 0 8px 0 16px;
        &::after {
          content: "";
          width: 16px;
          height: 16px;
          background: url("@/assets/img/content/next.png");
          background-size: 100% 100%;
          margin-left: 2px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
    .genre-list {
      padding-right: 20px;
      margin-top: 20px;
      .genre-item {
        box-sizing: border-box;
        width: 50%;
        margin-bottom: 20px;
        &:nth-child(odd) {
          padding-right: 20px;
        }
        &:nth-child(even) {
          padding-left: 20px;
        }
      }
    }
  }
}

.mobile-genre-main {
  .genre-box {
    margin-top: 20px;
    padding: 0 16px;
    .genre-title {
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
      span {
        &:first-of-type {
          text-transform: capitalize;
        }
      }
      .more {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .genre-list {
      margin-top: 16px;
      .genre-item {
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
}

@media screen and (min-width: 1800px) {
  .pc-genre-main {
    .genre-box {
      .genre-list {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 40px;
        .genre-item {
          box-sizing: border-box;
          width: 100%;
          &:nth-child(odd) {
            padding-right: 0px;
          }
          &:nth-child(even) {
            padding-left: 0px;
          }
        }
      }
    }
  }
}
</style>
